import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import scrollIntoView from 'scroll-into-view';
import RadioButton from 'shared/components/ui/radioButton';
import {
  selectDeliveryTime,
  selectDeliveryDate
} from 'shared/components/checkoutPage/actions';
import { trackNow } from 'shared/models/analytic';

const Icon = () => <span className="svg-icon svg-icon--time" />;

let Collapsed = class Collapsed extends React.Component {
  renderTitle() {
    return (
      <div>
        <h2 className="checkout-section__title">Delivery Time</h2>
      </div>
    );
  }

  renderSummary() {
    const isImmediateDelivery = this.props.slot.start === null;
    const date = this.props.date.date;
    const dateIsToday = moment().format('MM/DD/YYYY') === date;

    const summary =
      (isImmediateDelivery
        ? ''
        : dateIsToday
          ? 'Today, '
          : moment(new Date(date)).format('ddd, MMM D, ')) +
      this.props.slot.description;

    return (
      <div className="checkout-section__title checkout-section__title--selected">
        {summary}
      </div>
    );
  }

  render() {
    return _.isEmpty(this.props.slot)
      ? this.renderTitle()
      : this.renderSummary();
  }
};

Collapsed = connect(
  state => ({
    date: state.checkout.deliveryDate,
    slot: state.checkout.deliveryTime
  }),
  {}
)(Collapsed);

let Expanded = class Expanded extends React.Component {
  constructor(props) {
    super(props);

    this.immediateDeliverySlot = {
      description: props.availability.selection_text,
      start: null
    };

    const selectedTab =
      (!_.isEmpty(props.date) && props.date) ||
      (!_.isEmpty(props.availability.dates[0]) &&
        props.availability.dates[0]) ||
      {};

    this.state = {
      slotsExpanded: false,
      selectedTab,
      error: null
    };
  }

  componentDidMount() {
    this.checkInView(this.form);

    if (_.isEmpty(this.props.slot)) {
      const firstDate = this.props.availability.dates[0];
      this.selectTab(firstDate);
      if (this.props.availability.immediate_delivery) {
        this.selectSlot({ date: firstDate, slot: this.immediateDeliverySlot });
      }
    }
  }

  checkInView(el) {
    if (!el) return;
    const containerRect = el.getBoundingClientRect();
    if (containerRect && containerRect.top < 0) scrollIntoView(el);
  }

  expandSlots() {
    this.setState({ slotsExpanded: true });
    trackNow('Delivery Times View More Clicked');
  }

  collapseSlots() {
    this.setState({ slotsExpanded: false });
    this.checkInView(this.form);
    trackNow('Delivery Times View Fewer Clicked');
  }

  selectTab(date) {
    this.setState({ selectedTab: date });
  }

  selectSlot({ slot, date }) {
    this.props.selectDeliveryTime(slot);
    this.props.selectDeliveryDate(date);
  }

  handleSubmit(e) {
    e.preventDefault();
    if (_.isEmpty(this.props.slot)) {
      this.setState({ error: 'Please select a delivery time.' });
      return;
    }
    this.props.collapse();
  }

  dateIsToday({ date }) {
    return moment().format('MM/DD/YYYY') === date;
  }

  render() {
    const availability = this.props.availability;
    const dateOptions = availability.dates || [];
    const selectedTab = this.state.selectedTab;
    const selectedSlot = this.props.slot;
    const selectedDate = this.props.date;
    const slots = []
      .concat(
        availability.immediate_delivery && this.dateIsToday(selectedTab)
          ? this.immediateDeliverySlot
          : []
      )
      .concat(selectedTab.slots || []);
    const firstSlots = slots.slice(0, 5);
    const canViewMore = slots.length > firstSlots.length;
    const slotOptions = this.state.slotsExpanded ? slots : firstSlots;

    return (
      <div className="checkout-form-container">
        <h2 className="checkout-section__title checkout-section__title--expanded">
          Delivery Time
        </h2>

        <form
          onSubmit={e => this.handleSubmit(e)}
          ref={form => (this.form = form)}
        >
          {this.state.error && (
            <div className="warning">{this.state.error}</div>
          )}

          <div className="radio-list vertical-rhythm">
            <div className="tabs">
              {dateOptions.map(option => {
                const className =
                  option.date === selectedTab.date
                    ? 'tabs__tab tabs__tab--selected'
                    : 'tabs__tab';
                const heading = this.dateIsToday(option) ? 'Today' : option.day;
                const subheading = moment(new Date(option.date)).format(
                  'MMM D'
                );
                return (
                  <div
                    className={className}
                    key={option.date}
                    onClick={() => this.selectTab(option)}
                  >
                    <div className="tabs__tab-heading">{heading}</div>
                    <div>{subheading}</div>
                  </div>
                );
              })}
            </div>

            {slotOptions.map(option => {
              const key = `${option.description}`;
              const name = 'delivery-time';
              const id = `${name}_${option.description.replace(/\s/g, '')}`;
              const isChecked =
                option.description === selectedSlot.description &&
                selectedTab.date === selectedDate.date;
              const containerClass = isChecked
                ? 'radio-list__option radio-list__option--checked'
                : 'radio-list__option';
              const btnClass = isChecked
                ? 'radio-list__radio-btn radio-list__radio-btn--checked'
                : 'radio-list__radio-btn';

              return (
                <RadioButton
                  key={key}
                  name={name}
                  id={id}
                  checked={isChecked}
                  containerClass={containerClass}
                  onChange={() =>
                    this.selectSlot({ slot: option, date: selectedTab })}
                  btnClass={btnClass}
                >
                  <div className="radio-list__content">
                    <div className="row middle-xs">
                      <div className="col-xs">
                        <div>{option.description}</div>
                      </div>
                      <div className="col-xs-3">
                        <div className="radio-list__label radio-list__highlight radio-list__strong">
                          Free
                        </div>
                      </div>
                    </div>
                  </div>
                </RadioButton>
              );
            })}

            {canViewMore && (
              <div className="text-center">
                {this.state.slotsExpanded ? (
                  <button
                    type="button"
                    className="btn-small delivery-time__show-more"
                    onClick={() => this.collapseSlots()}
                  >
                    View Fewer <span className="svg-icon svg-icon--up-arrow" />
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn-small delivery-time__show-more"
                    onClick={() => this.expandSlots()}
                  >
                    View All <span className="svg-icon svg-icon--down-arrow" />
                  </button>
                )}
              </div>
            )}
          </div>

          <div className="row">
            <div className="col-xs-12 col-md-5 col-md-offset-7 col-lg-4 col-lg-offset-8">
              <button
                type="submit"
                className="btn-primary green btn--full-width"
              >
                Continue
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
};

Expanded = connect(
  state => ({
    availability: state.checkout.availability,
    date: state.checkout.deliveryDate,
    slot: state.checkout.deliveryTime
  }),
  { selectDeliveryTime, selectDeliveryDate }
)(Expanded);

export default {
  Icon,
  Collapsed,
  Expanded
};



// WEBPACK FOOTER //
// ./shared/components/checkoutPage/deliveryTime.js